var map = {
	"./keep-control/bg.jpg": 6026,
	"./keep-control/cover.jpg": 1798,
	"./keep-control/logo.png": 8707,
	"./keep-control/title.png": 1908,
	"./m-royal/bg.png": 4332,
	"./m-royal/cover.png": 6803,
	"./m-royal/logo.png": 387,
	"./m-royal/title.png": 1648,
	"./synthwave-is-dead/bg.jpg": 9463,
	"./synthwave-is-dead/cover.jpg": 7075,
	"./synthwave-is-dead/title.png": 4429
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7329;